Backbone = require 'backbone'

class SupportBaseTicketModel extends Backbone.Model
  initialize:()->
    @setReasonText()

  setReasonText: ->
    category = Groupon.Support.ContentModel.getCategory()
    SubCategory = Groupon.Support.ContentModel.getSubCategory()
    if category? && SubCategory?
      @reasonId = SubCategory.id
      @reasonText = SubCategory.text
      @reasonGroup = SubCategory.group
      @parentCategoryId = category.id
      @parentCategoryText = category.text
      @isDummyCategory = false
    else
      @reasonId = "direct_email_ticket_subcategory"
      @reasonText = I18n.translate('js.modules.support.default_reason')
      @parentCategoryId = "direct_email_ticket"
      @parentCategoryText = I18n.translate('js.modules.support.default_parent_category')
      @isDummyCategory = true

  populateOrderListInfo: (emailBasicData) ->
    if window.currentUser? && Groupon.Support.currentOrdersFilter.isOrdersInfoValid()
      emailBasicData.orderListInfo =
        hasOrders: Groupon.Support.OrdersCollection.hasOrders()
        hasSingleOrder: Groupon.Support.OrdersCollection.getNumberOfOrdersFetched() is 1

  getBasicTicketData: () ->
    currentUserFullName = window.getCurrentUserFullName()
    emailBasicData =
      support_id: ""
      reason: @reasonId
      reason_text: @reasonText
      reason_group: @reasonGroup
      parent_category: @parentCategoryId
      parent_category_text: @parentCategoryText
      currentOrder: Groupon.Support.currentOrder
      description: ""
      escalate_to_merchant: Groupon.Support.ContentModel.escalateToMerchant
      is_refund_eligible: Groupon.Support.ContentModel.isRefundEligible
      user_name: unless _.isEmpty(currentUserFullName) then currentUserFullName
      user_email: currentUser?.email
    @populateOrderListInfo(emailBasicData)
    emailBasicData

module.exports = SupportBaseTicketModel
